var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightBlueChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.500041 14.9999C0.40102 15.0001 0.304176 14.9708 0.221787 14.9159C0.139398 14.861 0.0751735 14.7828 0.037256 14.6914C-0.000661533 14.5999 -0.0105646 14.4992 0.00880217 14.4021C0.028169 14.305 0.0759338 14.2158 0.146041 14.1459L6.79304 7.4999L0.146041 0.853899C0.052154 0.760013 -0.000590571 0.632675 -0.00059057 0.499899C-0.000590569 0.367123 0.052154 0.239786 0.146041 0.145899C0.239927 0.0520124 0.367265 -0.000732421 0.500041 -0.000732422C0.632817 -0.000732423 0.760154 0.0520124 0.854041 0.145899L7.85404 7.1459C7.9006 7.19234 7.93755 7.24752 7.96275 7.30827C7.98796 7.36901 8.00094 7.43413 8.00094 7.4999C8.00094 7.56567 7.98796 7.63079 7.96275 7.69153C7.93755 7.75228 7.9006 7.80745 7.85404 7.8539L0.854041 14.8539C0.807522 14.9003 0.752313 14.9371 0.691571 14.9621C0.630829 14.9872 0.565746 15 0.500041 14.9999Z",
    fill: "#0276B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBlueChevron);
export default __webpack_public_path__ + "static/media/right-blue-chevron.9ef632a973675adaf0b2cc3fc90900fe.svg";
export { ForwardRef as ReactComponent };